export default "__VITE_ASSET__D2J0LE$C__"